import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import { rel } from '../../utils/rel';
class Checkmore extends React.Component {
    render() {
        const { content: { noAd, isComment, docUrl, docName, skey, pcUrl, speUrl }, } = this.props;
        let commentUrl = `//gentie.ifeng.com/view.html?docUrl=${docUrl}&docName=${encodeURIComponent(docName || '')}&skey=${skey}&pcUrl=${pcUrl}&speUrl=${speUrl}&${noAd ? '&noAd' : ''}`;
        if (docUrl && !docUrl.includes('//')) {
            commentUrl = `//gentie.ifeng.com/c/comment/${docUrl.replace('ucms_', '')}`;
        }
        if (!isComment) {
            return (React.createElement("div", { className: styles.showAllComment },
                React.createElement("a", { href: commentUrl, target: "_blank", rel: rel }, "\u67E5\u770B\u5168\u90E8\u8BC4\u8BBA>>")));
        }
        return null;
    }
}
Checkmore.propTypes = {
    content: PropTypes.object,
};
export default Checkmore;
